import React from 'react';
import ReactDOM from 'react-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import * as references from '@mysidewalk/references';

import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import ApplicationRoot from './application/ApplicationRoot';
import { API_DOMAIN, ROOT_DOMAIN, PROTOCOL } from './settings';

const queryClient = new QueryClient();

references.configure({
  root: ROOT_DOMAIN,
  domain: API_DOMAIN,
  protocol: PROTOCOL,
});

ReactDOM.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ApplicationRoot />
    </QueryClientProvider>
  </React.StrictMode>,
  document.getElementById('mysw'),
);
